<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <h3 class="card-title">
                                    Remover regra de alerta
                                </h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p class="mb-3">
                                    Tem certeza que deseja remover a regra de
                                    alerta <strong>{{ alertRule.name }}</strong
                                    >?<br />
                                    <span class="text-red"
                                        >Todos os jobs pendentes da fila serão
                                        removidos e esta ação não poderá ser
                                        desfeita!</span
                                    >
                                </p>
                                <div class="form-group">
                                    <label class="form-label"
                                        >Para confirmar a remoção, digite abaixo
                                        o texto
                                        <span class="bg-red-lt px-1">{{
                                            alertRule.name
                                        }}</span
                                        >:</label
                                    >
                                    <input
                                        id="confirmationInput"
                                        v-model="nameConfirmation"
                                        type="text"
                                        class="form-control"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col">
                                <a
                                    id="cancelAndBackButton"
                                    href="/alert-rules/"
                                    class="btn"
                                >
                                    <i class="ti ti-arrow-left"></i>
                                    Cancelar e voltar
                                </a>
                            </div>
                            <div class="col-auto">
                                <a
                                    id="removeQueueButton"
                                    class="btn btn-danger"
                                    @click="removeQueue"
                                >
                                    <i class="ti ti-trash"></i>
                                    Remover regra de alerta
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from "../services/api"
import EventBus from "../services/event-bus"

export default {
    name: "AlertRulesDeletePage",
    data() {
        return {
            nameConfirmation: "",
            alertRule: {}
        }
    },
    async mounted() {
        var id = this.$route.params.id
        var response = await Api.alertRules.get(id)
        this.alertRule = response.data
    },
    methods: {
        async removeQueue() {
            var id = this.$route.params.id

            try {
                if (this.validate()) {
                    await Api.alertRules.delete(id)

                    this.$router.push("/alert-rules")

                    EventBus.emit("message", {
                        type: "success",
                        message: "A regra de alerta foi removida com sucesso!"
                    })
                }
            } catch (error) {
                EventBus.emit("message", {
                    type: "error",
                    message: "Erro ao remover a regra de alerta:" + error
                })
            }
        },
        validate() {
            if (this.alertRule.name !== this.nameConfirmation) {
                EventBus.emit("message", {
                    type: "warning",
                    message:
                        "O nome da regra de alerta não confere com o nome digitado!"
                })

                return false
            }
            return true
        }
    }
}
</script>
